import MainContent from "../../../layouts/maincontent/MainContent";
import Lottie from "react-lottie";
import comming_soon from "../../../lotties/comming_soon.json";
import styleCommingSoon from "./CommingSoon.module.css";
import { useLocation, useNavigate } from "react-router-dom";

function CommingSoon() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: comming_soon,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const service = params.get("s");
  // Messages based on service
  const messages = {
    payment: "هذه الخدمة سيتم توفيرها عند إصدار التشريعات",
    appeal: "هذه الخدمة سيتم إتاحتها قريبا",
    dispute: "سيتم توفير الخدمة عند تجديد العمل بالقانون",
  };
  // Default message
  const message = messages[service] || "هذه الخدمة ستكون متاحة قريباً";

  const navigate = useNavigate();

  // Titles based on service (page name)
  const titles = {
    payment: "الدفع الإلكتروني للوحدات المميكنة",
    appeal: "الطعن الضريبى",
    dispute: "إنهاء المنازعات الضريبية",
    statement: "الكشف الرسمى",
  };

  // Default title
  const title = titles[service] || "خدمة";

  return (
    <MainContent>
      <section className={styleCommingSoon["commingSoon-section"]}>
        <div className={`${styleCommingSoon.container} container`}>
          <div className={styleCommingSoon.headerRow}>
            <button
              className={`${styleCommingSoon["btn-arrow"]} ms-3`}
              onClick={() => navigate(`/`)}
            >
              <i className="fa-solid fa-arrow-right mt-1"></i>
            </button>

            <h4 className={styleCommingSoon.title}>{title}</h4>
          </div>
          <div className="row justify-content-center">
            {/* <div className="col-md-6"> */}
            <div>
              <div className="text-center">
                <Lottie width="100%" height="100%" options={defaultOptions} />
              </div>
              <div className={`${styleCommingSoon["card-body"]} card-body`}>
                <h1
                  className={`${styleCommingSoon.order_message} text-center mt-5 fw-bolder`}
                >
                  {message}
                </h1>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default CommingSoon;
